import classNames from 'classnames';
import React from 'react';

import Icon from '../icons/Icon';

import css from './CheckInput.module.scss';

export enum InputType {
  Checkbox = 'checkbox',
  Radio = 'radio',
}

const LabelPosition = {
  FlexWrap: 'FlexWrap',
  SpaceBetween: 'SpaceBetween',
} as const;

type LabelPosition = typeof LabelPosition[keyof typeof LabelPosition];

interface Props extends React.ComponentProps<'input'> {
  labelPosition?: LabelPosition;
  type: InputType;
  onClick?: (e: React.MouseEvent) => void;
  onChange?: (e: React.ChangeEvent) => void;
}

const CheckInput = ({
  children,
  className,
  labelPosition,
  type,
  onClick,
  onChange,
  ...attr
}: Props) => {
  const classes = classNames(css.CheckInput, className);
  const labelClasses = classNames(css.CheckInput__Label, {
    [css.flex_space_between]: labelPosition === LabelPosition.SpaceBetween,
    [css.flex_wrap]: labelPosition === LabelPosition.FlexWrap,
  });

  return (
    <span className={classes}>
      <input
        {...attr}
        type={type}
        className={css.CheckInput__Input}
        onClick={onClick}
        onChange={onChange}
      />
      <Icon name="checkmark" className={css.CheckInput__Icon} />
      <span className={labelClasses}>{children}</span>
    </span>
  );
};

export default CheckInput;
